import { useEffect, useState } from "react"

import EventEmitter from "src/EventEmitter"

type useStudentControlsSubscriptionsProps = {
  localUserId: string
  mute: () => void
  unmute: () => void
}

const useStudentControlsSubscriptions = ({
  localUserId,
  mute,
  unmute,
}: useStudentControlsSubscriptionsProps) => {
  const [localControlsLocked, setLocalControlsLocked] = useState(true)

  useEffect(() => {
    const localUserIdString = String(localUserId)
    const lockAndMute = () => {
      setLocalControlsLocked(true)
      mute()
    }
    const unlock = () => setLocalControlsLocked(false)

    const onUserJoinedOrUpdated = ({
      controlsUnlockedUserIds,
    }: {
      controlsUnlockedUserIds?: string[]
    }) => {
      if (!controlsUnlockedUserIds) return

      const locked = !controlsUnlockedUserIds.includes(localUserIdString)
      setLocalControlsLocked(locked)
      if (locked) mute()
    }

    EventEmitter.subscribe("mute_all", mute)
    EventEmitter.subscribe("lock_all", lockAndMute)
    EventEmitter.subscribe("unlock_all", unlock)
    EventEmitter.subscribe("mute_user", mute)
    EventEmitter.subscribe("lock_user", lockAndMute)
    EventEmitter.subscribe("unlock_user", unlock)
    EventEmitter.subscribe("unmute_user", unmute)
    EventEmitter.subscribe("user_joined_or_updated", onUserJoinedOrUpdated)

    return () => {
      EventEmitter.unsubscribe("mute_all", mute)
      EventEmitter.unsubscribe("lock_all", lockAndMute)
      EventEmitter.unsubscribe("unlock_all", unlock)
      EventEmitter.unsubscribe("mute_user", mute)
      EventEmitter.unsubscribe("lock_user", lockAndMute)
      EventEmitter.unsubscribe("unlock_user", unlock)
      EventEmitter.unsubscribe("unmute_user", unmute)
      EventEmitter.unsubscribe("user_joined_or_updated", onUserJoinedOrUpdated)
    }
  }, [localUserId, mute, unmute])

  return { localControlsLocked }
}

export default useStudentControlsSubscriptions
